import { UserInfoService } from '@faro/app-context';
import { PollingChangeEventService, StudyService, SubStudyService } from '@faro/study-designer-services';
import { createSafeContext } from '../../../../util/createSafeContext';
import {
    CommandService,
    DiseaseAreasService,
    PublishedAgenticArtifactService,
    StudyDefinitionReferenceService,
    StudyPhasesService,
    StudySpaceChangeEventService,
    StudySpaceService,
    TherapeuticAreasService,
} from '../../service';
import { StudyDefinitionImportService } from '../../service/import/StudyDefinitionImportService';

/**
 * This context functions as our service registry, allowing consuming components to access services.
 */
export interface ServiceContextValue {
    readonly studySpaceChangeEventService: StudySpaceChangeEventService;
    readonly studyChangeEventService: PollingChangeEventService;
    readonly commandService: CommandService;
    readonly studySpaceService: StudySpaceService;
    readonly studyDefinitionReferenceService: StudyDefinitionReferenceService;
    readonly publishedAgenticArtifactService: PublishedAgenticArtifactService;
    readonly diseaseAreasService: DiseaseAreasService;
    readonly userInfoService: UserInfoService;
    readonly therapeuticAreasService: TherapeuticAreasService;
    readonly studyPhasesService: StudyPhasesService;
    readonly studyService: StudyService;
    readonly studyDefinitionImportService: StudyDefinitionImportService;
    readonly subStudyService: SubStudyService;
}

export const [ServiceContextValueProvider, useServiceContext, ServiceContext] =
    createSafeContext<ServiceContextValue>('StudySpaceService');
